var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCloseLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99948 7.05767L11.2993 3.75781L12.2421 4.70062L8.94228 8.00047L12.2421 11.3003L11.2993 12.2431L7.99948 8.94327L4.69965 12.2431L3.75684 11.3003L7.05668 8.00047L3.75684 4.70062L4.69965 3.75781L7.99948 7.05767Z",
    fill: "#B7C8D5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-line.7488eda2.svg";
export { ForwardRef as ReactComponent };